import React from 'react'
import styled from '@style'

import { themeGet } from '@style'
import { Box, Flex } from '@components/Grid'
import { Text } from '@components/Text'
import { Facebook, Instagram } from '@components/Icon'
import { Link } from '@components/Link'
import Background from './Background'

const IconWrapper = styled(Box)`
  padding: 4px;

  :hover {
    opacity: 70%;
    cursor: pointer;
  }
`
const LegalWrapper = styled(Flex)`
  padding-top: 2rem;
  border-top-style: solid;
  border-top-width: 1px;
  border-color: ${themeGet('colors.gray.400')};
`

const Footer = () => (
  <>
    <Background />
    <Flex px={[4, 5]} bg="gray.200" flexDirection="column" mt="auto">
      <Flex py={5} flexDirection={['column', 'row']}>
        {/* Follow us */}
        {/* <Box width={[1, 1 / 3]} pt={[4, 0]}>
          <Flex justifyContent="center" flexDirection="column">
            <Text fontWeight="semibold">Follow Us</Text>
            <Flex>
              <IconWrapper>
                <Facebook />
              </IconWrapper>
              <IconWrapper>
                <Instagram />
              </IconWrapper>
            </Flex>
          </Flex>
        </Box> */}
        {/* <Box width={[1, 1 / 3]} pt={[4, 0]}>
          <Flex flexDirection="column">
            <Text pb={[1, 4]} fontWeight="bold">Menu</Text>            
            <Link to="/case-studies">Projects</Link>
            <Link to="/about">About us</Link>
          </Flex>
        </Box> */}

        <Box width={[1, 1 / 3]} pt={[4, 0]}>
          <Flex flexDirection="column">
            <Text pb={[1, 4]} fontWeight="semibold">SUPPORT</Text>
            <Link to="mailto:hello@ofspots.com">hello@ofspots.com</Link>
          </Flex>
        </Box>

        <Box width={[1, 1 / 3]} pt={[4, 0]}>
          <Flex flexDirection="column">
            <Text pb={[1, 4]} fontWeight="semibold">UNTERNEHMEN</Text>            
            <Link to="/imprint">Impressum</Link>
            <Link to="/data-privacy">Datenschutz</Link>
          </Flex>
        </Box>
      </Flex>

      <LegalWrapper
        mb="auto"
        alignItems={['flex-start', 'flex-end']}
        flexDirection={['column', 'row']}
      >
        <Flex flexDirection="column" pb={2}>
          <Text fontSize={1} color="grey.800">
            Designed & build by Ducibus LTD
          </Text>
          <Text fontSize={1} color="grey.800">
            © 2021 Ducibus LTD
          </Text>
        </Flex>
        {/* <Box ml={[0, 'auto']}>
          <Text fontWeight="light" color="textMuted">
              Wir arbeiten hart, um Hürden für Quad-Abenteuer zu senken. Für alle.
            </Text>

          <Text fontSize={1} color="grey.800">
            Made with ❤️ in Cyprus
          </Text>
        </Box> */}
      </LegalWrapper>
    </Flex>
  </>
)

Footer.propTypes = {}

export default Footer
